// проверяет, есть ли выбранные маршруты, если нет то 'empty'. если есть то проверяет, можно ли создать вакансию (с разными проектами и разными ВСВ нельзя), и возвращает true или false
export const CheckBeforeCreate = (routes: any) => {
  const checkedItems = routes?.filter((item: any) => item.checked) || []

  if (checkedItems.length === 0) {
    return 'empty';
  } else {
    const firstCheckedItem = checkedItems[0];

    return checkedItems.every(
      (item: any) =>
        item.project.id === firstCheckedItem.project.id &&
        item.vsv === firstCheckedItem.vsv
    );
  }
};

// формирует объект для создания вакансии
export const dataForCreate = (routes: any) => {
  const checkedItems = routes.filter((item: any) => item.checked);
  const type = 'ON_ROUTE'
  const projectRoutes = checkedItems.reduce((acc: any, el: any) => {
    const existingProject = acc.find((item: any) => item.project.id === el.project.id);
    if (existingProject) {
        existingProject.routes.push(el.routeNo);
    } else {
        acc.push({ project: { id: el.project.id }, routes: [el.routeNo] });
    }
    return acc;
}, []);
  const result = {
    type: type,
    projectRoutes: projectRoutes
  }
  return result
}

export const dataForProjectRoutesCheckboxes = (checkboxes: any) => {
  if(checkboxes && checkboxes.length > 0) {
    const projectRoutes = checkboxes.reduce((acc: any, el: any) => {
      const existingProjectIndex = acc.findIndex((item: any) => item.project.id === el.project.id);
      if (existingProjectIndex !== -1) {
          acc[existingProjectIndex].routes.push(el.routeNo);
      } else {
          acc.push({ project: { id: el.project.id }, routes: [el.routeNo] });
      }
      return acc;
   }, []);
   return projectRoutes;
  }
 }
 

// формирует объект для создания вакансии через модальное окно
export const dataForCreateVacancyModal = (routes: any, list: any) => {
  const listById = list.reduce((acc: any, item: any) => ({ ...acc, [item.id]: { ...item, routes: [] } }), {});
  routes.forEach((el: any) => {
    if (listById[el.project.id]) {
      if (!listById[el.project.id].routes.includes(el.routeNo)) {
        listById[el.project.id].routes.push(el.routeNo);
      }
    }
  });
  const projectRoutes = Object.keys(listById).map(key => {
    return {
      project: { id: listById[key].id },
      routes: listById[key].routes
    }
  });
  return projectRoutes;
};

// формирует массив с маршрутами для удаления маршрутов из вакансии, вида [5, 6]
export const routesForDelete = (routes: any) => {
  if(routes) {
    const filteredRoutes = routes.filter((el: any) => el.checked === true)
    const result = filteredRoutes.map((el: any) => el.routeNo)
    return result
  }
}
